import type { Post } from '@/@types/post'
import { isEmpty } from 'lodash-es'
import AutoLoadMoreIndicator, { AutoLoadMoreIndicatorProps } from '../AutoLoadMoreIndicator'
import EmptyPlaceholder from '../EmptyPlaceholder'
import VirtualizedListItem from '../VirtualizedListItem'
import CompositePost from './CompositePost'
import styles from './PostList.module.css'

export interface PostListProps extends AutoLoadMoreIndicatorProps {
	/**
	 * Post 数据数组
	 */
	data: Post[]
}

export default function PostList({ data, isLoading, ...props }: PostListProps) {
	return (
		<>
			{!isLoading && isEmpty(data) ? (
				<EmptyPlaceholder title="这里空空如也" className={styles.emptyPlaceholder} />
			) : (
				data.map((post, index) => (
					<VirtualizedListItem key={`${post.id}_${index}`} id={post.id}>
						<CompositePost data={post} className={styles.post} />
					</VirtualizedListItem>
				))
			)}
			<AutoLoadMoreIndicator isLoading={isLoading} {...props} />
		</>
	)
}
